export const getOfficialRoles = () => {
  return [
    "COMMISSIONER",
    "CREW_CHIEF",
    "DOCTOR",
    "GROUNDSKEEPER",
    "MATCH_OFFICIAL",
    "REFEREE",
    "REFEREE_ASSISTANT",
    "REFEREE_RESERVE",
    "REFEREE_ASSISTANT_RESERVE",
    "SCORER",
    "SCORER_ASSISTANT",
    "SHOT_CLOCK_OPERATOR",
    "STATISTICIAN",
    "TIMER",
    "UMPIRE_1",
    "UMPIRE_2",

    // --- keeping UMPIRE to support older reports --- /
    "UMPIRE",
  ];
};

export const getPrimaryOfficials = () => {
  return [
    "COMMISSIONER",
    "CREW_CHIEF",
    "UMPIRE",
    "UMPIRE_1",
    "UMPIRE_2",
    "REFEREE",
  ];
};

export const getSecondaryOfficials = () => {
  const primaryRoles = getPrimaryOfficials();
  return getOfficialRoles().filter((role) => !primaryRoles.includes(role));
};
